"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.receiveFileDelete = receiveFileDelete;
exports.attemptFilesFetch = attemptFilesFetch;
exports.receiveFilesFetch = receiveFilesFetch;
exports.failFilesFetch = failFilesFetch;
exports.removeFile = removeFile;
exports.renameFile = renameFile;
exports.moveFile = moveFile;
exports.uploadFile = uploadFile;
exports.getEditedImageUploadSucceeded = getEditedImageUploadSucceeded;
exports.getEditedImageUploadFailed = getEditedImageUploadFailed;
exports.uploadEditedImage = uploadEditedImage;
exports.uploadResizedImage = uploadResizedImage;
exports.uploadFiles = uploadFiles;
exports.replaceFile = replaceFile;
exports.saveEdit = saveEdit;
exports.setVidyardSyncState = setVidyardSyncState;
exports.softDeleteHubLVideoPlayer = softDeleteHubLVideoPlayer;
exports.getSelectImageToEditAction = getSelectImageToEditAction;
exports.getDeselectImageToEditAction = getDeselectImageToEditAction;
exports.getFetchSignedURLFailedAction = getFetchSignedURLFailedAction;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _immutable = _interopRequireDefault(require("immutable"));

var _I18n = _interopRequireDefault(require("I18n"));

var FilesApi = _interopRequireWildcard(require("FileManagerCore/api/Files"));

var VideoPlayersApi = _interopRequireWildcard(require("FileManagerCore/api/VideoPlayers"));

var _Constants = require("FileManagerCore/Constants");

var _dimensions = require("FileManagerCore/utils/dimensions");

var _tempFileId = _interopRequireDefault(require("FileManagerCore/utils/tempFileId"));

var _file = require("FileManagerCore/utils/file");

var _ActionTypes = require("FileManagerCore/actions/ActionTypes");

var _Limits = require("FileManagerCore/actions/Limits");

var _hubLVideo = require("FileManagerCore/utils/hubLVideo");

var _notifications = require("FileManagerCore/utils/notifications");

function receiveFileDelete(fileId) {
  return {
    type: _ActionTypes.DELETE_FILE_SUCCEEDED,
    fileId: fileId
  };
}

function attemptFilesFetch(query) {
  return {
    type: _ActionTypes.FETCH_FILES_ATTEMPTED,
    status: _Constants.RequestStatus.PENDING,
    query: query
  };
}

function receiveFilesFetch(query, data) {
  return {
    type: _ActionTypes.FETCH_FILES_SUCCEEDED,
    status: _Constants.RequestStatus.SUCCEEDED,
    query: query,
    data: data
  };
}

function failFilesFetch(query, error) {
  return {
    type: _ActionTypes.FETCH_FILES_FAILED,
    status: error.status === 404 ? _Constants.RequestStatus.NOTFOUND : _Constants.RequestStatus.FAILED,
    query: query,
    error: error
  };
}

function removeFile(file) {
  return function (dispatch, getState, httpClient) {
    FilesApi.remove(file.get('id'), httpClient).then(function () {
      if ((0, _hubLVideo.isHubLVideo)(file.toJS())) {
        dispatch((0, _Limits.getDecreaseVideoQuantityUsedAction)(1));
      }

      dispatch(receiveFileDelete(file.get('id')));
    }, function (error) {
      dispatch({
        type: _ActionTypes.DELETE_FILE_FAILED,
        meta: {
          notification: {
            type: 'danger',
            titleText: _I18n.default.text('FileManagerCore.notifications.deleteFile.error.title'),
            message: _I18n.default.text('FileManagerCore.notifications.deleteFile.error.message', {
              filename: file.get('name')
            })
          }
        },
        error: error,
        file: file
      });
    }).done();
  };
}

function renameFile(file, newName) {
  return function (dispatch, getState, httpClient) {
    var newFile = file.set('name', newName);
    dispatch({
      type: _ActionTypes.RENAME_FILE_ATTEMPTED,
      data: newFile
    });
    FilesApi.move(file.get('id'), {
      name: newName
    }, httpClient).then(function (data) {
      dispatch({
        type: _ActionTypes.RENAME_FILE_SUCCEEDED,
        data: data
      });
    }, function (error) {
      var errorType = error && error.responseJSON ? error.responseJSON.errorType : '';

      var message = _I18n.default.text('FileManagerCore.notifications.renameFile.error.message', {
        filename: file.get('name')
      });

      if (errorType === 'FILE_MOVE_CONFLICT') {
        message = _I18n.default.text('FileManagerCore.notifications.renameFile.error.FILE_MOVE_CONFLICT');
      }

      dispatch({
        type: _ActionTypes.RENAME_FILE_FAILED,
        data: file,
        meta: {
          notification: {
            type: 'danger',
            titleText: _I18n.default.text('FileManagerCore.notifications.renameFile.error.title'),
            message: message
          }
        },
        error: error
      });
    }).done();
  };
}

function moveFile(file, destination) {
  return function (dispatch, getState, httpClient) {
    FilesApi.move(file.get('id'), {
      folder_id: destination
    }, httpClient).then(function (data) {
      dispatch({
        type: _ActionTypes.MOVE_FILE_SUCCEEDED,
        data: data
      });
    }, function (error) {
      var errorType = error && error.responseJSON ? error.responseJSON.errorType : '';

      var titleText = _I18n.default.text('FileManagerCore.notifications.moveFile.error.title'); // default message


      var message = _I18n.default.text('FileManagerCore.notifications.moveFile.error.message', {
        filename: file.get('name')
      });

      if (errorType === 'FILE_MOVE_CONFLICT') {
        message = _I18n.default.text('FileManagerCore.notifications.moveFile.error.FILE_MOVE_CONFLICT');
      }

      dispatch({
        type: _ActionTypes.MOVE_FILE_FAILED,
        meta: {
          notification: {
            type: 'danger',
            titleText: titleText,
            message: message
          }
        },
        error: error
      });
    }).done();
  };
}

function getUploadError(response) {
  var errorData = null;

  if (response.data) {
    if (typeof response.data === 'string') {
      try {
        errorData = JSON.parse(response.data);
      } catch (e) {} // eslint-disable-line no-empty

    } else if ((0, _typeof2.default)(response.data) === 'object') {
      errorData = response.data;
    }
  }

  return errorData;
}

var getUploadOptionsWithThumbnailGenerationMethod = function getUploadOptionsWithThumbnailGenerationMethod(options) {
  return (0, _extends2.default)({
    forceSynchronousImageProcessing: true
  }, options);
};

function uploadFile(file) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return function (dispatch, getState, httpClient) {
    var tempId = options.tempId || (0, _tempFileId.default)();

    var progress = function progress(event) {
      dispatch({
        type: _ActionTypes.UPLOAD_FILE_PROGRESS,
        progress: event.loaded / event.total * 95,
        tempId: tempId
      });
    };

    var _splitNameAndExtensio = (0, _file.splitNameAndExtension)(file),
        name = _splitNameAndExtensio.name,
        extension = _splitNameAndExtensio.extension;

    var type = (0, _file.getType)(extension);
    var isImage = type === _Constants.FileTypes.IMG;
    var tempUrl = '';

    if (isImage) {
      tempUrl = window.URL.createObjectURL(file);
    }

    var upload = function upload() {
      var dimensions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      dispatch({
        type: _ActionTypes.UPLOAD_FILE_ATTEMPTED,
        tempFile: file,
        folderId: options.folderId,
        dimensions: dimensions,
        tempUrl: tempUrl,
        tempId: tempId
      });
      return FilesApi.uploadFile(file, progress, getUploadOptionsWithThumbnailGenerationMethod(options), httpClient).then(function (data) {
        var uploadedFile = data.getIn(['objects', 0]);
        dispatch({
          type: _ActionTypes.UPLOAD_FILE_SUCCEEDED,
          file: data.getIn(['objects', 0]),
          tempId: tempId
        });

        if (tempUrl) {
          window.URL.revokeObjectURL(tempUrl);
        }

        return uploadedFile;
      }, function (response) {
        var message = _I18n.default.text('FileManagerCore.notifications.upload.error.message', {
          filename: name
        });

        var errorData = getUploadError(response);

        if (errorData && errorData.errorType === 'VIRUS_FOUND') {
          message = _I18n.default.text('FileManagerCore.notifications.upload.error.virusFoundMessage', {
            filename: name
          });
        }

        dispatch({
          type: _ActionTypes.UPLOAD_FILE_FAILED,
          meta: {
            notification: {
              type: 'danger',
              titleText: _I18n.default.text('FileManagerCore.notifications.upload.error.title'),
              message: message
            }
          },
          error: response,
          tempId: tempId
        });

        if (tempUrl) {
          window.URL.revokeObjectURL(tempUrl);
        }
      });
    };

    if (isImage && tempUrl) {
      return (0, _dimensions.getAsyncDimensions)(tempUrl).then(upload);
    }

    return upload();
  };
}

function getEditedImageUploadSucceeded(file, titleText) {
  return {
    type: _ActionTypes.UPLOAD_EDITED_IMAGE_SUCCEEDED,
    file: file,
    tempId: null,
    meta: {
      notification: {
        type: 'success',
        titleText: titleText
      }
    }
  };
}

function getEditedImageUploadFailed() {
  return {
    type: _ActionTypes.UPLOAD_EDITED_IMAGE_FAILED,
    meta: {
      notification: {
        type: 'danger',
        titleText: _I18n.default.text('FileManagerCore.notifications.uploadEditedFile.error.title'),
        message: _I18n.default.text('FileManagerCore.notifications.uploadEditedFile.error.message')
      }
    }
  };
}

function getTextForUploadEditedImgSuccess(file) {
  return _I18n.default.text('FileManagerCore.notifications.uploadEditedFile.success.title', {
    fileName: file.get('name')
  });
}

function uploadEditedImage(file, fileName, fileFolderId, onSaveComplete) {
  return function (dispatch, getState, httpClient) {
    dispatch({
      type: _ActionTypes.UPLOAD_EDITED_IMAGE_ATTEMPTED
    });
    return FilesApi.uploadEditedImage(file, fileName, fileFolderId, httpClient).then(function (data) {
      var savedFile = data.getIn(['objects', 0]);
      dispatch(getEditedImageUploadSucceeded(savedFile, getTextForUploadEditedImgSuccess(savedFile)));

      if (onSaveComplete) {
        onSaveComplete(savedFile.get('url'), savedFile);
      }
    }, function () {
      dispatch(getEditedImageUploadFailed());
    }).done();
  };
}

function uploadResizedImage(fileId, newWidth, onSaveComplete) {
  return function (dispatch, getState, httpClient) {
    dispatch({
      type: _ActionTypes.UPLOAD_EDITED_IMAGE_ATTEMPTED
    });
    return FilesApi.uploadResizedImage(fileId, newWidth, httpClient).then(function (file) {
      dispatch(getEditedImageUploadSucceeded(file, getTextForUploadEditedImgSuccess(file)));

      if (onSaveComplete) {
        onSaveComplete(file.get('url'), file);
      }
    }, function () {
      dispatch(getEditedImageUploadFailed());
    }).done();
  };
}

var getBulkUploadAttemptedAction = function getBulkUploadAttemptedAction(uploadingFiles, path) {
  return {
    type: _ActionTypes.BULK_UPLOAD_FILES_ATTEMPTED,
    uploadingFiles: uploadingFiles,
    path: path
  };
};

function uploadFiles(fileList) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var files = Array.prototype.slice.call(fileList);
  return function (dispatch) {
    dispatch(getBulkUploadAttemptedAction(files, options.path));
    files.forEach(function (file) {
      dispatch(uploadFile(file, options));
    });
  };
}

function replaceFile(fileId, file) {
  return function (dispatch, getState, httpClient) {
    var state = getState();

    var progress = function progress(event) {
      dispatch({
        type: _ActionTypes.REPLACE_FILE_PROGRESS,
        progress: event.loaded / event.total * 95,
        fileId: fileId
      });
    };

    var _splitNameAndExtensio2 = (0, _file.splitNameAndExtension)(file),
        extension = _splitNameAndExtensio2.extension;

    var type = (0, _file.getType)(extension);
    var isImage = type === _Constants.FileTypes.IMG;
    var originalFile = state.files.get('objects').find(function (aFile) {
      return aFile.get('id') === fileId;
    });
    var tempUrl = '';

    if (isImage) {
      tempUrl = window.URL.createObjectURL(file);
    }

    var upload = function upload() {
      var dimensions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      dispatch({
        type: _ActionTypes.REPLACE_FILE_ATTEMPTED,
        tempFile: file,
        dimensions: dimensions,
        tempUrl: tempUrl,
        fileId: fileId
      });
      return FilesApi.uploadFile(file, progress, {
        replaceFileId: fileId
      }, httpClient).then(function (response) {
        var updatedFile = response.getIn(['objects', 0]);
        updatedFile = updatedFile.merge({
          replaced: true
        }); // meta contains the old thumbnail for replaced files
        // so we clear it

        updatedFile = updatedFile.setIn(['meta', 'thumbs'], _immutable.default.Map());
        dispatch({
          type: _ActionTypes.REPLACE_FILE_SUCCEEDED,
          file: updatedFile
        });

        if (tempUrl) {
          window.URL.revokeObjectURL(tempUrl);
        }
      }, function (response) {
        var message = _I18n.default.text('FileManagerCore.notifications.replace.error.message', {
          filename: originalFile.get('name')
        });

        var errorData = getUploadError(response);

        if (errorData && errorData.errorType === 'VIRUS_FOUND') {
          message = _I18n.default.text('FileManagerCore.notifications.replace.error.virusFoundMessage', {
            filename: name
          });
        }

        dispatch({
          type: _ActionTypes.REPLACE_FILE_FAILED,
          meta: {
            notification: {
              type: 'danger',
              titleText: _I18n.default.text('FileManagerCore.notifications.replace.error.title'),
              message: message
            }
          },
          file: originalFile,
          error: response
        });

        if (tempUrl) {
          window.URL.revokeObjectURL(tempUrl);
        }
      }).done();
    };

    if (isImage && tempUrl) {
      (0, _dimensions.getAsyncDimensions)(tempUrl).then(upload);
    } else {
      upload();
    }
  };
}

function saveEdit(originalId, file, url) {
  return function (dispatch, getState, httpClient) {
    var tempId = (0, _tempFileId.default)();
    dispatch({
      type: _ActionTypes.SAVE_EDIT_ATTEMPTED,
      tempUrl: url,
      fileId: originalId,
      originalId: originalId,
      file: file,
      tempId: tempId
    });
    return FilesApi.downloadFromUrl(file, url, httpClient).then(function (response) {
      dispatch({
        type: _ActionTypes.SAVE_EDIT_SUCCEEDED,
        file: response,
        originalId: originalId,
        tempId: tempId
      });
      return response;
    });
  };
}

function getCreateVidyardPlayerSucceededAction(file) {
  return {
    type: _ActionTypes.CREATE_VIDYARD_PLAYERID_SUCCEEDED,
    file: file
  };
}

function getCreateVidyardPlayerAttemptedAction() {
  return {
    type: _ActionTypes.CREATE_VIDYARD_PLAYERID_ATTEMPTED
  };
}

function getCreateVidyardPlayerFailedAction() {
  return {
    type: _ActionTypes.CREATE_VIDYARD_PLAYERID_FAILED,
    meta: {
      notification: {
        type: 'danger',
        titleText: _I18n.default.text('FileManagerCore.notifications.syncToVidyard.error.title'),
        message: _I18n.default.text('FileManagerCore.notifications.syncToVidyard.error.message')
      }
    }
  };
}

function setVidyardSyncState(file) {
  return function (dispatch, getState, httpClient) {
    dispatch(getCreateVidyardPlayerAttemptedAction());
    VideoPlayersApi.createPlayerForVideo(file.get('id'), httpClient).then(function (newHostingInfo) {
      dispatch(getCreateVidyardPlayerSucceededAction((0, _file.getUpdatedPlayerIdVideoFile)(file, newHostingInfo)));
    }, function () {
      return dispatch(getCreateVidyardPlayerFailedAction());
    }).done();
  };
}

function getDeleteVidyardPlayerFailedAction() {
  return {
    type: _ActionTypes.SOFT_DELETE_VIDYARD_PLAYERID_FAILED,
    meta: {
      notification: {
        type: 'danger',
        titleText: _I18n.default.text('FileManagerCore.notifications.unsyncFromVidyard.error.title'),
        message: _I18n.default.text('FileManagerCore.notifications.unsyncFromVidyard.error.message')
      }
    }
  };
}

function getDeleteVidyardPlayerSucceededAction(file) {
  return {
    type: _ActionTypes.SOFT_DELETE_VIDYARD_PLAYERID_SUCCEEDED,
    file: file
  };
}

function softDeleteHubLVideoPlayer(playerId, file) {
  return function (dispatch, getState, httpClient) {
    VideoPlayersApi.softDeleteHubLVideoPlayer(playerId, httpClient).then(function () {
      return dispatch(getDeleteVidyardPlayerSucceededAction((0, _file.softDeleteVidyardPlayerIdFromFile)(file, playerId)));
    }, function () {
      return dispatch(getDeleteVidyardPlayerFailedAction());
    }).done();
  };
}

function getSelectImageToEditAction(file, selectedImgFrom) {
  return {
    type: _ActionTypes.IMAGE_TO_EDIT_SELECTED,
    file: file,
    selectedImgFrom: selectedImgFrom
  };
}

function getDeselectImageToEditAction() {
  return {
    type: _ActionTypes.IMAGE_TO_EDIT_DESELECTED
  };
}

function getFetchSignedURLFailedAction() {
  return {
    type: _ActionTypes.FETCH_SIGNED_URL_FAILED,
    meta: {
      notification: (0, _notifications.getFetchSignedURLFailedNotification)()
    }
  };
}